import React from "react"
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";
import BaseComponent from "../../../base-component";
import {Collapse} from "reactstrap";
import Cleave from 'cleave.js/src/Cleave.react';
import CountrySelect from "../../../country-select";

class Page5 extends BaseComponent {

    constructor(params) {
        super(params);
    }

    renderForeigner() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, isComplete } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <h3><FormattedMessage id='app.personal_forms.page_5_foreign.title'/></h3>
                <p><FormattedMessage id='app.personal_forms.page_5_foreign.info'/></p>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.first_cr_employment'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage><br/>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.first_cr_employment' name='data.first_cr_employment' type="radio" value={values.data.first_cr_employment} checked={values.data.first_cr_employment === '1'} onChange={() => { setFieldValue('data.first_cr_employment', '1') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.first_cr_employment', '1'); }}><FormattedMessage id='app.personal_forms.attribute.first_cr_employment.true'/></label>
                            </div>
                            <div className='custom-control custom-radio'>
                                <input className='custom-control-input' disabled={isComplete} id='data.first_cr_employment' name='data.first_cr_employment' type="radio" value={values.data.first_cr_employment} checked={values.data.first_cr_employment === '0'} onChange={() => { setFieldValue('data.first_cr_employment', '0') }} onBlur={handleBlur}/>
                                <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.first_cr_employment', '0') }}><FormattedMessage id='app.personal_forms.attribute.first_cr_employment.false'/></label>
                            </div>
                            { displayErrors(errors, 'data.first_cr_employment') }
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <div className='form-group'>
                                <label><FormattedMessage id='app.personal_forms.attribute.foreigner_insurance_number'/></label>
                                <Cleave options={{
                                    numericOnly: true,
                                    blocks: [10]
                                }}
                                        value={values.data.foreigner_insurance_number}
                                        disabled={isComplete}
                                        className={'form-control'}
                                        onChange={(event) => { setFieldValue('data.foreigner_insurance_number', event.target.rawValue) }} />
                                <div className='small text-muted shift'><FormattedMessage id='app.personal_forms.attribute.foreigner_insurance_number.info'/></div>
                                { displayErrors(errors, 'data.foreigner_insurance_number') }
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.foreigner_identification_number'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <Cleave options={{
                                    numericOnly: true,
                                    blocks: [10]
                                }}
                                        value={values.data.foreigner_identification_number}
                                        disabled={isComplete}
                                        className={'form-control'}
                                        onChange={(event) => { setFieldValue('data.foreigner_identification_number', event.target.rawValue) }} />
                                <div className='small text-muted shift'><FormattedMessage id='app.personal_forms.attribute.foreigner_identification_number.info'/></div>
                                { displayErrors(errors, 'data.foreigner_identification_number') }
                            </div>
                        </div>
                    </div>
                </div>

                <div className='clearfix'>
                    <hr/>
                    <button type='button' className='btn btn-secondary' onClick={this.props.previous}>{intl.formatMessage({id: 'app.personal_forms.buttons.previous_step'})}</button>
                    { !isComplete && <button type='submit' className='btn btn-primary float-right' disabled={isSubmitting}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}{this.spinner(isSubmitting)}</button> }
                    { isComplete && <button type='button' className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.props.next}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}</button> }
                </div>
            </form>
        )
    }

    renderCzech() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, isComplete } = this.props;
        const formatPostcode = ['CZE', 'SVK'].includes(values.data.foreign_pension_beneficiary_address_country);
        return (
            <form onSubmit={handleSubmit}>
                <h3><FormattedMessage id='app.personal_forms.page_5_czech.title'/></h3>
                <p><FormattedMessage id='app.personal_forms.page_5_czech.info'/></p>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }

                <div className='form-group'>
                    <FormattedMessage id='app.personal_forms.attribute.foreign_pension'>{(txt) => (<label>{txt}</label>)}</FormattedMessage><br/>
                    <div className='custom-control custom-radio'>
                        <input className='custom-control-input' disabled={isComplete} id='data.foreign_pension' name='data.foreign_pension' type="radio" value={values.data.foreign_pension} checked={values.data.foreign_pension === '1'} onChange={() => { setFieldValue('data.foreign_pension', '1') }} onBlur={handleBlur}/>
                        <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.foreign_pension', '1') }}><FormattedMessage id='app.personal_forms.attribute.foreign_pension.true'/></label>
                    </div>
                    <div className='custom-control custom-radio'>
                        <input className='custom-control-input' disabled={isComplete} id='data.foreign_pension' name='data.foreign_pension' type="radio" value={values.data.foreign_pension} checked={values.data.foreign_pension === '0'} onChange={() => { setFieldValue('data.foreign_pension', '0') }} onBlur={handleBlur}/>
                        <label className='custom-control-label' onClick={() => { !isComplete && setFieldValue('data.foreign_pension', '0') }}><FormattedMessage id='app.personal_forms.attribute.foreign_pension.false'/></label>
                    </div>
                    { displayErrors(errors, 'data.foreign_pension') }
                </div>

                <Collapse isOpen={values.data.foreign_pension === '1'}>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_name'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_name' value={values.data.foreign_pension_beneficiary_name} onChange={handleChange}/>
                                { displayErrors(errors, 'data.foreign_pension_beneficiary_name') }
                            </div>
                        </div>
                    </div>

                    <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_address'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_address_street'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_address_street' value={values.data.foreign_pension_beneficiary_address_street} onChange={handleChange}/>
                                { displayErrors(errors, 'data.foreign_pension_beneficiary_address_street') }
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_address_city'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_address_city' value={values.data.foreign_pension_beneficiary_address_city} onChange={handleChange}/>
                                { displayErrors(errors, 'data.foreign_pension_beneficiary_address_city') }
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_address_country'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                <CountrySelect disabled={isComplete} value={values.data.foreign_pension_beneficiary_address_country} onChange={(value) => { setFieldValue('data.foreign_pension_beneficiary_address_country', value) }}/>
                                { displayErrors(errors, 'data.foreign_pension_beneficiary_address_country') }
                            </div>
                            {
                                formatPostcode &&
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_address_postcode'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                    <Cleave options={{
                                        blocks: [3, 2],
                                        numericOnly: true
                                    }}
                                            value={values.data.foreign_pension_beneficiary_address_postcode}
                                            disabled={isComplete}
                                            className={'form-control'}
                                            onChange={(event) => { setFieldValue('data.foreign_pension_beneficiary_address_postcode', event.target.value) }} />
                                    { displayErrors(errors, 'data.foreign_pension_beneficiary_address_postcode') }
                                </div>

                            }
                            {
                                !formatPostcode &&
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_address_postcode'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                    <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_address_postcode' value={values.data.foreign_pension_beneficiary_address_postcode} onChange={handleChange}/>
                                    <div className='small text-muted shift'><FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_address_postcode.info'/></div>
                                    { displayErrors(errors, 'data.foreign_pension_beneficiary_address_postcode') }
                                </div>
                            }
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_identifier'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.foreign_pension_beneficiary_identifier' value={values.data.foreign_pension_beneficiary_identifier} onChange={handleChange}/>
                                <div className='small text-muted shift'><FormattedMessage id='app.personal_forms.attribute.foreign_pension_beneficiary_identifier.info'/></div>
                                { displayErrors(errors, 'data.foreign_pension_beneficiary_identifier') }
                            </div>
                        </div>
                    </div>
                </Collapse>

                <div className='clearfix'>
                    <hr/>
                    <button type='button' className='btn btn-secondary' onClick={this.props.previous}>{intl.formatMessage({id: 'app.personal_forms.buttons.previous_step'})}</button>
                    { !isComplete && <button type='submit' className='btn btn-primary float-right' disabled={isSubmitting}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}{this.spinner(isSubmitting)}</button> }
                    { isComplete && <button type='button' className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.props.next}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}</button> }
                </div>
            </form>
        );
    }

    render() {
        const { resource } = this.props;
        if ( resource.data['citizenship'] === 'CZE') {
            return this.renderCzech();
        } else {
            return this.renderForeigner();
        }
    }

}

export default injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { data: { ...props.resource.data, page: 6 } };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(Page5));
